import { S3Client } from "@aws-sdk/client-s3";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";

const AWS_REGION = import.meta.env.VITE_AWS_REGION || "ap-northeast-1";
const COGNITO_IDENTITY_POOL_ID = import.meta.env.VITE_COGNITO_IDPOOL_ID || "";
const COGNITO_USERPOOL_ID = import.meta.env.VITE_COGNITO_USERPOOL_ID || "";

/**
 * Cognito認証を使用してS3クライアントを作成
 */
export async function createS3Client(idToken: string): Promise<S3Client> {
	return new S3Client({
		region: AWS_REGION,
		credentials: fromCognitoIdentityPool({
			clientConfig: { region: AWS_REGION },
			identityPoolId: COGNITO_IDENTITY_POOL_ID,
			logins: {
				[`cognito-idp.${AWS_REGION}.amazonaws.com/${COGNITO_USERPOOL_ID}`]: idToken,
			},
		}),
	});
}
